import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ActiveComponent } from './active/active.component';
import { AppliedJobsComponent } from './applied-jobs/applied-jobs.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'active',
    pathMatch: 'full',
  },
  {
    path: 'active',
    component: ActiveComponent
  },
  {
    path: 'applied',
    component: AppliedJobsComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class JobRoutingModule {}
